<template lang="pug">
  v-row
    v-col(cols=12 md=10 lg=8)
      enrollment-form(
        :course-id="$route.params.id"
      )
</template>

<script>
import EnrollmentForm from '@/components/Forms/EnrollmentForm.vue';

export default {
  components: {
    EnrollmentForm,
  },
};
</script>
